<template>
  <div>
    <el-dialog title="请设置业户房产关系" :visible.sync="dialogVisible" width="800px" :before-close="handleClose" :close-on-click-modal="false">
      <el-descriptions border size="small" :column="2">
        <el-descriptions-item label="业主姓名">{{fromData.name}}</el-descriptions-item>
        <el-descriptions-item label="业主电话">{{fromData.contact_number}}</el-descriptions-item>
        <el-descriptions-item label="业主身份证">{{fromData.credentials_code}}</el-descriptions-item>
        <el-descriptions-item label="业主房产">{{fromData.house_name}}</el-descriptions-item>
        <el-descriptions-item label="业主房产状态">
          <el-select v-if="fromData.house_id" v-model="fromData.status" placeholder="请选择业户关系" size="mini">
            <el-option
              v-for="item in type_list"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-descriptions-item>

      </el-descriptions>
      <div slot="footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="submit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// {
//   "id": 740436,
//   "organization_project_id": 110,
//   "class": 1,
//   "type": "1",
//   "number": null,
//   "name": "邹益康",
//   "contact_number": "17708692218   13318366368",
//   "credentials_code": "362522199801250035",
//   "organization": "",
//   "update_time": 1725266735,
//   "operator": "何海燕1",
//   "is_delete": 0,
//   "delete_time": 0,
//   "status": 3,
//   "house_id": 1522595,
//   "customer_house_id": 1290025,
//   "project_id": 110,
//   "house_name": "佛山风度花园项目->区域1->住宅11座->403",
//   "customer_house_status": "业主",
//   "all_order_count": 18,
//   "order_count": 0,
//   "organization_name": "佛山风度花园项目"
// }
export default {
  name: "SelectCustomerHouseStatus",
  data() {
    return {
      dialogVisible: false,
      type_list:[
        {"id": 3, "name": "业主", "type_id": 12},
        {"id": 6, "name": "历史业主", "type_id": 8},
        {"id": 7, "name": "租户", "type_id": 3},
        {"id": 8, "name": "历史租户", "type_id": 2}
      ],
      fromData: {},
      callback: null,
    };
  },
  methods: {
    show(item, callback){
      this.fromData = item;
      this.dialogVisible = true;
      this.callback = callback;
    },
    handleClose() {
      this.dialogVisible = false;
      this.callback=null;
      this.fromData = {};
    },
    submit() {
      const that=this;
      ERP.postRequest({
        url: "admin/CustomerHouse/setCustomerHouseStatus",
        data: {
          id: that.fromData.customer_house_id,
          status: that.fromData.status,
        },
      },ret=>{
        if(ret.code){
          that.dialogVisible = false;
          that.callback(that.fromData);
          that.fromData = {};
        }else {
          that.$message.error(ret.msg);
        }
      })

    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/Customer/components/SelectCustomerHouseStatus.vue